module.exports = __webpack_public_path__ + "img/background.5774ebda.png";